module.exports = __webpack_public_path__ + "img/PBS_0233.5c7f2305.jpg";